export default __webpack_public_path__ + "static/media/manage-users.952fcbbe.svg";